import i18next from "i18next";
import { toastService } from "../../../component/common/toast-messages/toast";
import Actions from "../../actions";
import { getUserProfileAction } from "../auth/authServices";
import * as requestFromServer from "./commonApis";

// update refund -> api
export const searchPersonAction =
  (dataToBeSent, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.searchPerson(dataToBeSent);
    if (response) {
      setLoading(false);
      dispatch(
        Actions.createAction(Actions.SEARCH_PERSON_SELECT_LIST, {
          searchPersonSelectList: response,
        })
      );
      return response;
    } else {
      setLoading(false);
      return null;
    }
  };

export const getTermsAndConditionsAction = (setLoading) => async (dispatch) => {
  setLoading(true);
  const response = await requestFromServer.getTermsAndConditions();
  if (response) {
    setLoading(false);
    dispatch(
      Actions.createAction(Actions.GET_TERMS_AND_CONDITIONS_LIST, {
        termsAndConditions: response,
      })
    );
    return response;
  } else {
    setLoading(false);
    return null;
  }
};

export const acceptTermsAndConditionsAction =
  (setLoading, setUserSession, onClose) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.acceptTermsAndConditions();
    if (response) {
      /* setting the user session based on roles */
      dispatch(getUserProfileAction(setUserSession));
      /* setting the user session based on roles */
      setLoading(false);
      onClose();
      return response;
    } else {
      setLoading(false);
      return null;
    }
  };

export const updateKeyValueAction =
  (dataToBeSent, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.updateKeyValue(dataToBeSent);
    if (response) {
      toastService.success(response?.message);
      setLoading(false);
      return response;
    } else {
      setLoading(false);
      return null;
    }
  };

export const payFineAction = (dataToBeSent, setLoading) => async (dispatch) => {
  setLoading(true);
  const response = await requestFromServer.payFine(dataToBeSent);
  if (response) {
    setLoading(false);
    return response;
  } else {
    setLoading(false);
    return null;
  }
};

export const getFineTransactionHistoryAction =
  (dataToBeSent, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.getFineTransactionHistory(
      dataToBeSent
    );
    if (response) {
      setLoading(false);
      dispatch(
        Actions.createAction(Actions.GET_FINE_TRANSACTION_HISTORY_LIST, {
          fineTransactionHistory: response,
        })
      );
      return response;
    } else {
      setLoading(false);
      return null;
    }
  };

//Notifications
export const getAllNotifications = (dataToBeSent) => async (dispatch) => {
  const response = await requestFromServer.getLatestNotifications(dataToBeSent);
  if (response) {
    dispatch(Actions.createAction(Actions.FETCHED_ALL_NOTIFICATIONS, response));
    return response;
  } else {
    return null;
  }
};

export const markAsRead = (dataToBeSent) => async (dispatch) => {
  const response = await requestFromServer.markNotification(dataToBeSent);
  if (response) {
    dispatch(getAllNotifications());
    return response;
  } else {
    return null;
  }
};

export const checkSponsorshipAction =
  (dataToBeSent, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.checkSponsorship(dataToBeSent);
    if (response) {
      setLoading(false);
      dispatch(
        Actions.createAction(Actions.CHECK_SPONSORSHIP_AVAILABILITY, {
          sponsorshipAvailability: response,
        })
      );
      return response;
    } else {
      setLoading(false);
      return null;
    }
  };

export const deleteUserAccount = (dataToBeSent) => async (dispatch) => {
  try {
    const response = await requestFromServer.deleteAccount(dataToBeSent);
    return response; // assuming that the response from the server is the desired data
  } catch (error) {
    // Handle errors here
    console.error("Error deleting user account:", error);
    throw error; // Rethrow the error to be caught in the calling function
  }
};

export const downloadCustomerAppointmentPdfAction =
  (dataToBeSent, setLoading, downloadUrl) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.downloadCustomerAppointmentPdf(
      dataToBeSent
    );
    if (response) {
      downloadUrl(response?.invoice_url);
      setLoading(false);
      return response;
    } else {
      setLoading(false);
      return null;
    }
  };

// create service provider support ticket -> api
export const createServiceProviderSupportTicketAction =
  (formData, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.createServiceProviderSupportTicket(
      formData
    );
    if (response) {
      setLoading(false);
      if (response.statusCode === 200) {
        toastService.success(response.message);
      } else {
        toastService.error(response.message);
      }
      return response;
    } else {
      setLoading(false);
      return null;
    }
  };
